import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, styled, Stack } from '@mui/material'
import { Typography as MIUTypography, Button as BT } from '@mui/material'
import LoginIcon from '@mui/icons-material/Login'
import EmailInput from '../../components/EmailInputForm'
import { verifyEmail, sendEmailResetPassword } from '../../services'
import AlertCustom from '../../components/Alerts'
import { LOGIN_ROUTE } from '../../config/routes'

const Typography = styled(MIUTypography)(props => ({
  fontFamily: props.theme.typography.fontFamily,
  fontStyle: 'normal',
  fontSize: '1em',
  fontWeight: props.istitle ? 700 : 450,
  lineHeight: '24px',
  color: props.istitle ? '#1B1C37' : '#6A6A6A',
  textAlign: 'center',
}))

const Button = styled(BT)(({ theme }) => ({
  color: '#FFF',
  backgroundColor: theme.palette.primary.main,
  '&:hover': { backgroundColor: '4F4F4F' },
  '&:focus': {
    boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
  },
}))

const styleStack = {
  direction: 'column',
  alignItems: 'center',
  spacing: 1,
  width: '100%',
}

const ForgotPassword = () => {
  const navigate = useNavigate()
  const [send, setSend] = React.useState(false)
  const [error, setError] = React.useState(false)
  const alertRef = React.useRef()

  const [isStored, setIsStored] = React.useState(null)

  const handleClickLogin = () => navigate(LOGIN_ROUTE)

  const handleClickReset = async value => {
    const isUser = await verifyEmail(value.email)
    if (!isUser.auth) setError(true)

    const response = await sendEmailResetPassword(value.email)
    if (response?.error) {
      setIsStored({ stored: false, message: response.message })
      alertRef?.current?.openAlert(true)
    } else setSend(true)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Stack {...styleStack}>
        {send && (
          <Box pt={1}>
            <Typography
              sx={theme => ({
                color: theme.palette.text.white,
                fontWeight: 600,
                fontSize: '1.12em',
              })}>
              "Se ha enviado las instrucciones para el cambio de contraseña al correo
              electrónico registrado. Revise su bandeja de entrada."
            </Typography>
          </Box>
        )}
        {!send && (
          <Box>
            <EmailInput onSubmit={handleClickReset} error={error} />
          </Box>
        )}
        <Box pt={4}>
          <Box>
            <Button
              variant="contained"
              startIcon={<LoginIcon />}
              onClick={handleClickLogin}
              sx={theme => ({
                backgroundColor: theme.palette.primary.main,
                fontWeight: 600,
                fontSize: '0.8rem',
              })}>
              Iniciar Sesión
            </Button>
          </Box>
        </Box>
      </Stack>
      <AlertCustom
        ref={alertRef}
        severity={isStored?.stored !== true ? 'warning' : 'success'}>
        {isStored?.stored !== true ? isStored?.message : 'Guardado exitosamente.'}
      </AlertCustom>
    </Box>
  )
}

export default ForgotPassword
